<template>
    <div v-if="this.data.length > 10 && this.$store.state.resize.w > 768" class='d-flex align-items-center justify-content-between col-12 px24 py12'>
        <div class="d-flex align-items-center flex-column flex-md-row flex-wrap justify-content-between col-12 p-0">
            <div class="neue fsp14 text-black fw-medium" id="c-pg-1" :class="this.$store.state.resize.w < 992 ? 'mb-2 text-center' : ''">
                {{ this.$t('components.service.pagination.5') }}: {{ this.calcLeftValue() }} - {{ this.calcRightValue() }}  {{ this.$t('components.service.pagination.6') }} {{ this.data.length }}
            </div>
            <div class="d-flex align-items-center justify-content-center" :class="this.$store.state.resize.w < 992 ? 'mb-2' : ''">
                <div @click="moveTo(this.page - 1)" class="pagination-item mr8 neue" :class="{ 'disable': this.page == 1 }">
                    <Icon :name="'chevron-left'" :active="this.page != 1" />
                </div>
                <ul class="pagination pagination-sm mb-0" v-if="this.buttons.length > 0">
                    <li v-for="row in this.buttons" :key="row"
                    class="pagination-item"
                    :id="'c-pg-d' + row"
                    :class="{'active': row == this.page, 'disable': row === '...'}" 
                    v-on:click='() => {this.changePage(row)}' 
                    aria-current="page">
                        <span :id="'c-pg-dt' + row" class="neue ">{{row}}</span>
                    </li>
                </ul>
                <div @click="moveTo(this.page + 1)" class="pagination-item ml8 neue" :class="{ 'disable': this.page == this.pages }">
                    <Icon :name="'chevron-right'" :active="this.page != this.pages" />
                </div>
            </div>
            <div class="d-flex align-items-center">
                <SelectSimple
                    id='amount_group'
                    class="w64"
                    :keywords.sync='this.amount_list'
                    :dataValue='this.amount_group'
                    @updateParentState="this.updateAmount"
                    :hotUpdate="true"
                    :isPaginationSelect="true"
                />
            </div>
        </div>
    </div>
</template>

<script>
import SelectSimple from '@/components/service/SelectSimple';
import Icon from '@/components/icons/Icon';

export default {
    components: {
        SelectSimple,
        Icon
    },
    props: {
        data: [Array, Object],
        count: {
            type: [Number, Boolean],
            default: 10,
        },
        max: {
            type: [Number, Boolean],
            default: 6,
        },
        savePage: {
            type: Boolean,
        }
    },
    watch: {
        data: {
            handler: function(newData, oldData) {
                    // console.log(oldData)
                    // console.log(newData)
                // if (newData != oldData) { 
                    // console.log('handler data', this.data);
                    // this.pages = false;
                    if(newData.length > 0 && this.isFullContent) {
                        this.amount_val = newData.length
                    }
                    this.content = {};
                    this.getPages();
                    this.setData();
                    // console.log('handler content', this.content);

                    if (this.savePage && this.pages >= this.page) {
                        this.page = this.page;
                    } else {
                        this.page = 1;
                    }
                    this.setButtons();
                    this.returnContent();
                    // console.log('handler this.content', this.content);
                // }
            },
            deep: true,
        },
        isFullContent: {
            handler: function() {
                if(this.isFullContent) {
                    this.amount_val = this.data.length
                } else {
                    this.amount_val = 10
                    this.amount_group = '0'
                }
                this.setPagination()
            },
            immediate: true
        }
    },
    data() {
        return {
            pages: false,
            page: 1,
            content: {},
            buttons: [],
            amount_group: '0',
            amount_list: [
                {code: '0', value: '10'},
                {code: '1', value: '50'},
                {code: '2', value: '100'}
            ],
            amount_val: 10,
        }
    },
    mounted() {
        // console.log('mounted pagination', this.data);
        if (this.data) {
            this.setPagination()
        }
    },
    computed: {
        isFullContent() {
            return this.$store.state.resize.w <= 768
        }
    },
    methods: {
        setPagination() {
            this.pages = false;
            this.content = {};
            this.getPages();
            this.setData();
            this.page = 1;
            this.setButtons();
            this.returnContent();
        },
        moveTo(page) {
            if(page < 1 || page > this.pages) {
                return
            }
            this.page = page
            this.setButtons()
            this.changePage(page)
        },
        returnContent() {
            // console.log('returnContent this.page', this.page);
            // console.log('returnContent this.content', this.content);
            // console.log(this.content[this.page])
            // let res = Object.assign({}, this.content[this.page]);
            let res = this.content[this.page];
            // console.log('returnContent res', res);
            this.$emit('updateContentState', res);
        },
        getPages() {
            this.pages = Math.ceil(this.data.length / this.amount_val);
        },
        setData() {
            let tmp = 0;
            this.content = {};
            for (let i = 0; i < this.pages; i ++  ) {
                this.content[i + 1] = this.data.slice(tmp, this.amount_val + tmp);
                tmp += this.amount_val;
            }
        },
        changePage(i) {
            if(i === '...') {
                return
            }
            this.page = i;
            this.setButtons();
            this.returnContent();
            this.calcLeftValue();
            this.calcRightValue();
        },
        calcLeftValue() {
            return Number((this.page - 1) * this.amount_val + 1);
        },
        calcRightValue() {
            if (this.amount_val > this.data.length) {
                return this.data.length;
            }

            if (this.page == 1) {
                return this.amount_val;
            }

            const rightValue = Number(this.page * this.amount_val);

            return rightValue > this.data.length ? this.data.length : rightValue;
        },
        setButtons() {
            this.buttons = [];
            const allButtons = Object.keys(this.content)
            let buttons = []
            if(this.pages <= 5) {
                buttons.push(...allButtons)
            } else if((this.page == 1 || this.page == 2) && this.pages > 5) {
                buttons.push(...allButtons.slice(0,3))
                buttons.push('...')
                buttons.push(this.pages)
            } else if(this.page == 3) {
                buttons.push(...allButtons.slice(0,4))
                buttons.push('...')
                buttons.push(this.pages) 
            } else if(this.pages - this.page === 2) {
                buttons.push(1)
                buttons.push('...')
                buttons.push(...allButtons.slice(allButtons.length - 4, allButtons.length)) 
            } else if (this.pages >= 3 && this.pages - this.page > 2) {
                buttons.push(...allButtons.slice(+this.page - 2, +this.page + 1))
                buttons.push('...')
                buttons.push(this.pages)
            } else if(this.pages >= 3 && this.pages - +this.page <= 2) {
                buttons.push(1)
                buttons.push('...')
                buttons.push(...allButtons.slice(allButtons.length - 3, allButtons.length))
            }
            this.buttons = buttons
        },
        updateAmount(arg) {
            setTimeout(() => {
                const amountCode = arg.value;
                this.amount_group = amountCode;
                
                const val = this.amount_list.find(item => item.code == amountCode).value;

                this.amount_val = val ? Number(val) : '';

                if (this.amount_val) {
                    this.changePage(1);
                    this.getPages();
                    this.setData();
                    this.returnContent();
                    this.setButtons();
                    this.calcLeftValue();
                    this.calcRightValue();
                }
            }, 500);
        }
    },    
}
</script>

<style lang="scss">
.pagination {
    gap: 8px;
    
    .disable {
        cursor: auto;
    }
}
.pagination-item {
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background-color: white;
    color: black;
    cursor: pointer;
    border-radius: 8px;
    border: 1px solid $primary-stroke; 

    &:focus:not(.disable),
    &:hover:not(.disable),
    &:focus:not(.disable),
    &:hover:not(.disable) {
        background-color: $bg-light-grey;
    }
}
.w64 {
    min-width: 64px;
    font-size: 14px;
}

.pagination > .active {
    color: black;
    background-color: $bg-light-grey;
    filter: saturate(200%);
}
</style>